import { connect } from "react-redux";
import React from "react";
import {API} from "aws-amplify";
import makeStyles from '@mui/styles/makeStyles';
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import InputAdornment from "@mui/material/InputAdornment";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { toast } from "react-toastify";
import InputLabel from "@mui/material/InputLabel";
import Input from "@mui/material/Input";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import _ from "lodash";

import {
    requestNewSMSNumber,
    fetchSMSSetting,
    updateSMSConfig,
    TRANSACTION_KEY
} from "@/shared/connect_config/actions";
import { SUCCESS } from "@/shared/lifecycleStates";
import { clearTransaction } from "@/shared/transaction_state/actions";

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    updateSMSConfig: (body) => dispatch(updateSMSConfig(body)),
    requestSMSSetting: () => dispatch(fetchSMSSetting()),
    clearTransaction: (key) => dispatch(clearTransaction(key))
})

const useStyles = makeStyles(theme => ({
    panel: {
        marginTop: theme.spacing(1),
    },
    panelHeader: {
        marginLeft: theme.spacing(1)
    },
    inboxNameInput: {
        margin: theme.spacing(1),

    },
    button: {
        margin: theme.spacing(3),
    },
    instructions: {
        margin: theme.spacing(1),
    },
    phoneNumber: {
        padding: theme.spacing(2),
        margin: theme.spacing(2),
        backgroundColor: "lightgray",
        borderRadius: "5px",
        width: "150px"
    },
    smsConfigGroup: {
        margin: theme.spacing(1),
        padding: theme.spacing(1)
    }
}));

function ManageSMSSettings(props) {
    var { } = props;
    const classes = useStyles();
    const [loadActionsCalled, setLoadActionsCalled] = React.useState(false);
    const [suggestedAreaCodes, setSuggestedAreaCodes] = React.useState([]);
    const [areaCodeError, setAreaCodeError] = React.useState('');
    const [loadingSuggestions, setLoadingSuggestions] = React.useState(false);
    const [selectedCode, setSelectedCode] = React.useState('');
    const areaCodeRef = React.createRef();
    const defaultGreetingRef = React.createRef();

    if (!loadActionsCalled) {
        props.clearTransaction(TRANSACTION_KEY);
        props.requestSMSSetting();
        setLoadActionsCalled(true);
    }

    const requestNewNumber = () => {
        const areaCode = areaCodeRef.current.value;
        let configObj = { areaCode }

        API.post('Core', '/api/v1/sms-processing/request-number', {body: configObj})
            .then(response => {
                    toast.success("Successfully claimed the phone numbers", {position: "top-center"});
                    setSuggestedAreaCodes([]);
                    setAreaCodeError('');
                    setSelectedCode('');
                    props.clearTransaction(TRANSACTION_KEY);
                },
                error => {
                    toast.error(error.response.data.message, {position: "top-center"});
                    props.clearTransaction(TRANSACTION_KEY);
                    setAreaCodeError(`(${areaCode}) area code is not available to claim the number. Select the suggested available area code from the dropdown.`);
                    setLoadingSuggestions(true);
                    setSuggestedAreaCodes([]);
                    API.get('Core', `/api/v1/sms-processing/suggested-area-codes?areaCode=${areaCode}`)
                        .then(suggestions => { setSuggestedAreaCodes(suggestions); setLoadingSuggestions(false); })
                        .catch(() => { setLoadingSuggestions(false); });
                }
            );
    }

    const handleSuggestedAreaCodeSelect = (e) => {
        const code = e.target.value;
        setSelectedCode(code);
        setAreaCodeError('');
        if (areaCodeRef.current) {
            areaCodeRef.current.value = code;
        }
    }

    const updateConfig = () => {
        let body = Object.assign({}, props.connectConfig.sms);
        body.defaultGreeting = defaultGreetingRef.current.value;
        props.updateSMSConfig(body);
        props.clearTransaction(TRANSACTION_KEY);

    }

    const limitLength = (e) => {
        const parsed = parseInt(e.target.value);
        e.target.value = isNaN(parsed) ? '' : Math.max(0, parsed).toString().slice(0, 3);
    }

    let error = false;
    if (props.transactions[TRANSACTION_KEY]) {
        if (props.transactions[TRANSACTION_KEY].state === SUCCESS) {
            toast.success("Successfully Issued a new number!", { position: "top-center" });
            props.clearTransaction(TRANSACTION_KEY);
            props.requestSMSSetting();
        }
    }

    return (
        <Grid className={classes.panel} item>
            <Paper elevation={2}>
                <Typography className={classes.panelHeader} variant={"h6"}>Text Message Settings</Typography>
                <Divider></Divider>
                {
                    (_.get(props, "connectConfig.sms.phoneNumber")) ?
                        (<div>
                            <Typography className={classes.instructions} color={"textSecondary"}>Below is the phone number you should give clients if they want to text you with requests. Once it is received you will have an opportunity to route it to the correct person.</Typography>
                            <Typography className={classes.phoneNumber}>{_.get(props, "connectConfig.sms.phoneNumber")}</Typography>
                        </div>) :
                        (
                            <div>
                                <Typography className={classes.instructions} color={"textSecondary"}>Before clients start texting you, you need to claim a phone number. Enter your area code and we will issue a number in that area code.</Typography>

                                {/* Grid: col 1 = input / label, col 2 = button / dropdown.
                                    Error spans both columns so all four elements stay column-aligned. */}
                                <div style={{ display: 'grid', gridTemplateColumns: 'auto auto', justifyContent: 'start' }}>

                                    {/* Row 1 col 1: unchanged area code input */}
                                    <FormControl className={classes.inboxNameInput}>
                                        <InputLabel>Area Code</InputLabel>
                                        <Input
                                            error={error}
                                            inputRef={areaCodeRef}
                                            size="small"
                                            maxLength={3}
                                            onChange={limitLength}
                                            endAdornment={<InputAdornment position="end">)</InputAdornment>}
                                            startAdornment={<InputAdornment position="start">(</InputAdornment>}
                                        />
                                    </FormControl>

                                    {/* Row 1 col 2: unchanged claim button */}
                                    <Button variant="contained" color="primary" className={classes.button} onClick={requestNewNumber}>
                                        Claim New Phone Number
                                    </Button>

                                    {/* Row 2: error spans both columns — 508c: aria-live="polite" */}
                                    {areaCodeError && (
                                        <Typography
                                            variant="body2"
                                            style={{ color: 'red', gridColumn: '1 / -1', margin: '4px 8px 8px' }}
                                            aria-live="polite"
                                            aria-atomic="true"
                                        >
                                            {areaCodeError}
                                        </Typography>
                                    )}

                                    {/* Row 3 col 1: "Available Area Codes" label — 508c: bound to Select via htmlFor */}
                                    {(loadingSuggestions || suggestedAreaCodes.length > 0) && (
                                        <Typography
                                            id="area-code-suggestions-label"
                                            variant="body2"
                                            style={{ whiteSpace: 'nowrap', fontWeight: 500, alignSelf: 'center', padding: '4px 8px' }}
                                        >
                                            Available Area Codes
                                        </Typography>
                                    )}

                                    {/* Row 3 col 2: loading text or dropdown — 508c: role="region", aria-busy on loading */}
                                    {(loadingSuggestions || suggestedAreaCodes.length > 0) && (
                                        <div
                                            role="region"
                                            aria-label="Available area code suggestions"
                                            style={{ alignSelf: 'center', margin: '4px 24px' }}
                                        >
                                            {loadingSuggestions ? (
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    style={{ fontStyle: 'italic' }}
                                                    aria-live="polite"
                                                    aria-busy="true"
                                                >
                                                    Loading available area codes…
                                                </Typography>
                                            ) : (
                                                <FormControl style={{ minWidth: 260 }}>
                                                    <Select
                                                        inputProps={{ id: 'area-code-suggestions-select' }}
                                                        value={suggestedAreaCodes.find(s => s.areaCode === selectedCode) ? selectedCode : ''}
                                                        onChange={handleSuggestedAreaCodeSelect}
                                                        displayEmpty
                                                        aria-labelledby="area-code-suggestions-label"
                                                    >
                                                        <MenuItem value="" disabled>Select the area code</MenuItem>
                                                        {suggestedAreaCodes.map(suggestion => (
                                                            <MenuItem key={suggestion.areaCode} value={suggestion.areaCode}>
                                                                {suggestion.displayLabel}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            )}
                                        </div>
                                    )}

                                </div>
                            </div>
                        )
                }
            </Paper>
        </Grid>
    )

}

export default connect(mapStateToProps, mapDispatchToProps)(ManageSMSSettings);
